<template>
  <div style="display: contents;">
    <template v-for="(category, categoryIndex) in pack.categories">
      <category
        v-if="!categoryIndex || !categoriesCollapsed"
        :result="result"
        :category="category"
        :currency="currency"
        :packageName="pack.name"
        :transport="transport"
        :showHotelName="!categoryIndex"
        :showCollapse="!categoryIndex && pack.categories.length > 1"
        :categoriesCollapsed="categoriesCollapsed"
        :allMealsCollapsed="allMealsCollapsed"
        :noCategories="pack.categories.length"
        @toggle="$emit('toggle')"
        @categoriesToggle="categoriesCollapsed = !categoriesCollapsed"
        :selected="selected"
        :displaySelection="pack.displaySelection"
        :displayPackageName="pack.displayPackageName"
        :displayHotelName="pack.displayHotelName"
        @info="$emit('info')"
        :key="'c' + categoryIndex"
        @book="$emit('book',{ categoryId: category.id, ...$event })"
        @priceDetails="$emit('priceDetails', {category, ...$event})"
      />
    </template>
  </div>
</template>

<script>
import category from '@/app/private/shared/components/category_result'

export default {
  props: {
    currency: { type: String, default: 'EUR' },
    transport: { type: String },
    result: { type: Object },
    pack: { type: Object },
    selected: { type: Boolean },
    displaySelection: { type: Boolean, default: true },
    displayPackageName: { type: Boolean },
    displayHotelName: { type: Boolean },
    allMealsCollapsed: { type: Boolean },
    allCategoriesCollapsed: { type: Boolean }
  },
  components: { category },
  data () {
    return {
      categoriesCollapsed: false
    }
  },
  watch: {
    allCategoriesCollapsed (val) {
      this.categoriesCollapsed = val
    }
  }
}
</script>
